import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  FreightClaimPOPayload,
  UploadFreightClaimAttachmentFile
} from "../interface";
import {
  deleteFreightClaimAttachmentsCall,
  getStoreCreditDetails,
  getTransferPOProducts,
  postPoCreate,
  uploadFreightClaimAttachmentsCall
} from "src/api/sp";

export const uploadFreightClaimAttachments = createAsyncThunk(
  "uploadFreightClaimAttachments",
  (fcUploadAttachmentPayload: UploadFreightClaimAttachmentFile) =>
    uploadFreightClaimAttachmentsCall(fcUploadAttachmentPayload)
);

export const deleteFreightClaimAttachments = createAsyncThunk(
  "deleteFreightClaimAttachments",
  (filePath: string) => {
    deleteFreightClaimAttachmentsCall(filePath);
  }
);

export const createFreightClaimPO = createAsyncThunk(
  "createFreightClaimPO",
  (freightClaimPayload: FreightClaimPOPayload) =>
    postPoCreate(freightClaimPayload)
);

export const getTransferPOProductsForFC = createAsyncThunk(
  "getTransferPOProductsForFC",
  ({ receivingDocId, storeId }: { receivingDocId: number; storeId: string }) =>
    getTransferPOProducts({ receivingDocId, storeId })
);

export const getStoreCreditDetailsForFC = createAsyncThunk(
  "getStoreCreditDetailsForFC",
  ({
    storeId,
    referenceTransfer,
    type
  }: {
    storeId: string;
    referenceTransfer: number;
    type: string;
  }) => getStoreCreditDetails({ storeId, referenceTransfer, type })
);
